var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_56119",
    "data-name": "Group 56119",
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.904,
    height: 90.846,
    viewBox: "0 0 92.904 90.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56118",
    "data-name": "Group 56118",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_664",
    "data-name": "Ellipse 664",
    cx: 13.314,
    cy: 13.314,
    r: 13.314,
    transform: "translate(7.146 5.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_665",
    "data-name": "Ellipse 665",
    cx: 16.25,
    cy: 16.25,
    r: 16.25,
    transform: "translate(36.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135468",
    "data-name": "Path 135468",
    d: "M89.038,48.521l-12.53,7.146V47.15a6.977,6.977,0,0,0-6.95-6.95H9.45A6.977,6.977,0,0,0,2.5,47.15V88.266a6.977,6.977,0,0,0,6.95,6.95H69.558a6.977,6.977,0,0,0,6.95-6.95V79.749L88.941,86.9a4.285,4.285,0,0,0,6.461-3.72V52.241A4.212,4.212,0,0,0,89.038,48.521ZM49.783,69.764l-15.467,9.1a2.447,2.447,0,0,1-3.72-2.056V58.6a2.447,2.447,0,0,1,3.72-2.056l15.467,9.1A2.317,2.317,0,0,1,49.783,69.764Z",
    transform: "translate(-2.5 -4.371)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentries);
export default __webpack_public_path__ + "static/media/documentries.541a4da19f40246185db0710c85cdb8b.svg";
export { ForwardRef as ReactComponent };